// ---- TEQ: Facet class + header enhancer -------------------------------
function setupFacetClassEnhancer() {
  var ROOT_SELECTOR = '.ais-facets';
  var FACET_WRAPPER_SELECTOR = '.ais-facet-dropdown-wrapper';

  function slugifyFacetName(raw) {
    if (!raw) return '';

    var decoded = raw;
    try {
      decoded = decodeURIComponent(raw);
    } catch (e) {
      decoded = raw.replace(/%20/g, ' ');
    }

    return decoded
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')   // spaces → dashes
      .replace(/[^\w-]/g, ''); // strip weird chars
  }

  function relabelAvailabilityFacetOptions(root) {
    if (!root) return;

    var outOfStockLabel =
      (window.variantStrings && window.variantStrings.outOfStock) || 'Available on Request';
    var outOfStockPatterns = ['out of stock', 'nicht vorrätig'];

    root.querySelectorAll('.ais-RefinementList-labelText').forEach(function (labelNode) {
      if (labelNode.dataset.teqAvailabilityRelabeled === '1') return;

      var text = (labelNode.textContent || '').trim().toLowerCase();
      var isOutOfStock = outOfStockPatterns.some(function (pattern) {
        return text === pattern;
      });

      if (!isOutOfStock) return;

      labelNode.textContent = outOfStockLabel;
      labelNode.dataset.teqAvailabilityRelabeled = '1';
    });
  }

  function enhanceFacets(root) {
    if (!root) return;

    // Root wrapper class
    root.classList.add('teq-facets-root');

    var wrappers = root.querySelectorAll(FACET_WRAPPER_SELECTOR);
    if (!wrappers.length) return;

    Array.prototype.forEach.call(wrappers, function (wrapper, index) {
      // Generic class for all facets
      wrapper.classList.add('teq-facet');

      // ----- 1) Add attribute-based class: teq-facet--price, teq-facet--vendor, etc.
      var facetName = null;
      wrapper.className.split(/\s+/).forEach(function (cls) {
        if (cls.indexOf('ais-facet-') === 0 && cls !== 'ais-facet-dropdown-wrapper') {
          facetName = cls.replace('ais-facet-', '');
        }
      });

      if (facetName) {
        var slug = slugifyFacetName(facetName);

        try {
          wrapper.dataset.facetAttribute = decodeURIComponent(facetName);
        } catch (e) {
          wrapper.dataset.facetAttribute = facetName;
        }

        if (slug) {
          wrapper.classList.add('teq-facet--' + slug);
        }
      }

      // ----- 2) Make header look like Shopify's <button class="facet-toggle"> -----
      var label = wrapper.querySelector('.ais-facet--header');
      var checkbox = wrapper.querySelector('.ais-dropdown-checkbox');

      // Only process once
      if (!label || label.dataset.teqFacetToggle === '1') return;

      var text = label.textContent.trim();

      // Mark as enhanced
      label.dataset.teqFacetToggle = '1';

      // Add Shopify facet classes
      label.classList.add('facet-toggle');

      // Replace label contents with Shopify-like structure
      label.innerHTML = [
        '<span class="facet-toggle-label">',
        text,
        '</span>',
        '<span class="angle angle-down">',
        '  <span class="angle-icon"></span>',
        '</span>',
      ].join('');

      var angleSpan = label.querySelector('.angle');

      // Keep aria-expanded and "open" class in sync with checkbox
      if (checkbox) {
        // -------- INITIAL STATE: first 3 facets open, rest collapsed --------
        if (index < 3) {
          // open
          checkbox.checked = false;              // theme: unchecked = open
          wrapper.classList.add('teq-facet--open');
        } else {
          // collapsed
          checkbox.checked = true;               // theme: checked = closed
          wrapper.classList.remove('teq-facet--open');
        }

        var updateExpanded = function () {
          var open = !checkbox.checked; // open when NOT checked
          label.setAttribute('aria-expanded', open ? 'true' : 'false');
          wrapper.classList.toggle('teq-facet--open', open);

          if (angleSpan) {
            angleSpan.classList.toggle('angle-down', !open);
            angleSpan.classList.toggle('angle-up', open);
          }
        };

        // Apply initial state + keep in sync on user interaction
        updateExpanded();
        checkbox.addEventListener('change', updateExpanded);
      }
    });

    relabelAvailabilityFacetOptions(root);
  }


  function initObserver(root) {
    if (!root || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      enhanceFacets(root);
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function start() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (root) {
      enhanceFacets(root);
      initObserver(root);
      return;
    }

    // In case Algolia mounts later
    var attempts = 0;
    var maxAttempts = 20;
    var timer = setInterval(function () {
      attempts += 1;
      var el = document.querySelector(ROOT_SELECTOR);
      if (el || attempts >= maxAttempts) {
        clearInterval(timer);
        if (el) {
          enhanceFacets(el);
          initObserver(el);
        }
      }
    }, 250);
  }

  start();
}

// ---- TEQ: Force grid view on mobile ----------------------
function setupMobileGridView() {
  var BREAKPOINT = 749; // Mobile breakpoint in px

  function applyGridOnMobile() {
    if (typeof window === 'undefined') return;

    // get the ais-page wrapper
    var page = document.querySelector('.ais-page');
    if (!page) return;

    if (window.innerWidth <= BREAKPOINT) {
      // Remove list-view class so layout is grid/block
      page.classList.remove('ais-results-as-list');

      // Fix the toggle buttons' visual + aria state
      var blockBtn = document.querySelector('.ais-change-display-block');
      var listBtn = document.querySelector('.ais-change-display-list');

      if (blockBtn) {
        blockBtn.classList.add('ais-change-display-selected');
        blockBtn.setAttribute('aria-pressed', 'true');
      }

      if (listBtn) {
        listBtn.classList.remove('ais-change-display-selected');
        listBtn.setAttribute('aria-pressed', 'false');
      }
    }
  }

  // Run once now and again on resize/orientation change
  if (typeof window !== 'undefined') {
    applyGridOnMobile();
    window.addEventListener('resize', applyGridOnMobile);
    window.addEventListener('orientationchange', applyGridOnMobile);
  }
}

function setupAutocompletePricePOA() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function updateAutocompletePrices() {
    var priceNodes = document.querySelectorAll('.aa-ItemContentPriceCurrent');

    Array.prototype.forEach.call(priceNodes, function (node) {
      var raw = (node.textContent || '').trim();
      if (!raw) return;

      // If already converted, skip
      if (raw === 'POA') return;

      // Use shared helper to normalize to cents
      var cents = teqNormalizePriceToCents(raw);
      if (cents == null) return;

      // Zero price → show POA
      if (cents === 0) {
        node.textContent = 'POA';
        return;
      }

      // Non-zero → reformat nicely using Shopify.formatMoney (via teqFormatPriceFromRaw)
      node.textContent = null
    });
  }

  // Run once in case the panel is already rendered
  updateAutocompletePrices();

  if (typeof MutationObserver === 'undefined') return;

  // Watch for autocomplete dropdown being added / re-rendered
  var observer = new MutationObserver(function (mutations) {
    var touchedAutocomplete = mutations.some(function (m) {
      if (!m.addedNodes || !m.addedNodes.length) return false;
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return (
          n.nodeType === 1 &&
          (n.classList.contains('aa-Panel') ||
            (typeof n.closest === 'function' && n.closest('.aa-Panel')))
        );
      });
    });

    if (touchedAutocomplete) {
      updateAutocompletePrices();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function setupTaxifyRescan() {
  if (typeof window === 'undefined') return;

  // Try once immediately
  function tryRescan() {
    var taxify = window.Taxify;
    if (!taxify || typeof taxify.rescanAllElements !== 'function') {
      return false;
    }

    try {
      taxify.rescanAllElements();
      
      // console.log('Taxify rescanAllElements called');
    } catch (e) {
      console.error('Taxify rescanAllElements failed', e);
    }
    return true;
  }

  // If it works immediately, return
  if (tryRescan()) return;

  // Else, poll a few times in case Taxify loads later
  var attempts = 0;
  var maxAttempts = 20; // ~5 seconds at 250ms
  var timer = setInterval(function () {
    attempts += 1;
    if (tryRescan() || attempts >= maxAttempts) {
      clearInterval(timer);
    }
  }, 250);
}

function teqNormalizePriceToCents(raw) {
  if (raw == null) return null;

  // If Algolia gives us a number, it's a price in currency units (e.g. 130.8 => €130.80)
  if (typeof raw === 'number') {
    return Math.round(raw * 100);
  }

  // If it's a string, clean it and treat it as currency units too
  if (typeof raw === 'string') {
    var str = raw.trim();
    if (!str) return null;

    // Keep only digits, comma, dot, minus
    str = str.replace(/[^0-9,.-]/g, '');
    if (!str) return null;

    // Normalize comma to dot for parsing
    str = str.replace(',', '.');

    var n = parseFloat(str);
    if (!isFinite(n)) return null;

    // n is in euros → convert to cents
    return Math.round(n * 100);
  }

  return null;
}

function teqFormatPriceFromRaw(raw) {
  var cents = teqNormalizePriceToCents(raw);
  if (cents == null) return '';

  // Preferred path: Shopify's own formatMoney (respects EUR/German format)
  try {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var format = Shopify.money_format || '{{amount}}';
      return Shopify.formatMoney(cents, format);
    }
  } catch (e) {
    console.error('TEQ formatMoney error', e);
  }

  // Fallback: basic German-style EUR formatting
  var amount = cents / 100;
  try {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (e) {
    // Last-resort: very simple format
    return String(amount.toFixed(2)).replace('.', ',') + ' €';
  }
}

function teqDisplayPriceFromHit(hit, distinct) {
  if (!hit) return '';

  // Optional: show a range on distinct hits if Algolia provides min/max
  if (
    distinct &&
    hit.variants_min_price != null &&
    hit.variants_max_price != null &&
    hit.variants_min_price !== hit.variants_max_price
  ) {
    var minFormatted = teqFormatPriceFromRaw(hit.variants_min_price);
    var maxFormatted = teqFormatPriceFromRaw(hit.variants_max_price);

    if (minFormatted && maxFormatted && minFormatted !== maxFormatted) {
      return minFormatted + ' – ' + maxFormatted;
    }
  }

  // Normal case: format the variant’s own price
  return teqFormatPriceFromRaw(hit.price);
}


document.addEventListener('algolia.hooks.initialize', function () {
  try {
    setupFacetClassEnhancer();
    setupMobileGridView();
    setupAutocompletePricePOA();
  } catch (e) {
    console.error('TEQ facet class enhancer failed', e);
  }

  try {
    setupTaxifyRescan();
  } catch (error) {
    console.log('Taxify custom hook rescanAllElements error', error);
  }

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    function (_defaultTemplate, hit, html, components) {

      const inStock = !!hit.can_order;
      const outOfStockLabel =
        (window.variantStrings && window.variantStrings.outOfStock) || 'Available on Request';

      var productUrl = algoliaShopify.helpers.instantsearchLink(hit);

      return html`
        <article
          class="ais-hit teq-product-card card card-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          style="
            flex-direction:column;
            background:#ffffff;
            border:1px solid #e0e0e0;
            border-radius:3px;
            box-shadow:0 1px 3px rgba(0,0,0,0.08);
            padding:20px 20px 18px;
            min-height:460px;
          "
        >
          <a
            href="${algoliaShopify.helpers.instantsearchLink(hit)}"
            class="product-card__link"
            title="${algoliaShopify.helpers.fullTitle(
        hit.title,
        hit._distinct,
        hit.variant_title
      )}"
            style="
              flex:1 1 auto;
              display:flex;
              flex-direction:column;
              text-decoration:none;
              color:inherit;
            "
          >
            <div
              class="product-card__image-wrapper"
              style="text-align:center;margin-bottom:16px;"
            >
              <img
                class="product-card__image"
                src="${algoliaShopify.helpers.mediumImage(hit)}"
                alt="${hit.title} - ${hit.variant_title}"
              />
            </div>

            <div
              class="product-card__body card-info"
              style="flex:1 1 auto;display:flex;flex-direction:column;text-align:left;"
            >
              <p
                class="product-card__vendor"
                style="margin:0 0 4px;font-size:11px;color:#777777;"
              >
                ${hit.vendor}
              </p>

              <h4 class="product-card__title">
                ${components.Highlight({ attribute: 'title', hit })}
                ${algoliaShopify.helpers.variantTitleAddition(
        hit,
        hit._distinct
      )}
              </h4>

              <div class="product-card__meta-row">
                <span
                  style="
                    display:inline-flex;
                    align-items:center;
                    padding:5px 10px;
                    border-radius:20px;
                    font-size:11px;
                    background:${inStock ? '#e6f6e6' : '#fbeaea'};
                    color:${inStock ? '#1a7f37' : '#c0392b'};
                    white-space:nowrap;
                  "
                >
                  <span
                    style="
                      display:inline-block;
                      width:7px;
                      height:7px;
                      border-radius:50%;
                      margin-right:6px;
                      background:${inStock ? '#2ecc71' : '#e74c3c'};
                    "
                  ></span>
                  ${inStock ? 'AVAILABLE' : outOfStockLabel}
                </span>

                <div class="rating">
                    <div class="rating-stars" role="img" aria-label=" out of  stars">
                      <svg fill="none" focusable="false" role="presentation" class="icon-rating-star icon-rating-star-empty" viewBox="0 0 896 832">
                        <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
                      </svg>
                      <svg fill="none" focusable="false" role="presentation" class="icon-rating-star icon-rating-star-empty" viewBox="0 0 896 832">
                        <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
                      </svg>
                      <svg fill="none" focusable="false" role="presentation" class="icon-rating-star icon-rating-star-empty" viewBox="0 0 896 832">
                        <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
                      </svg>
                      <svg fill="none" focusable="false" role="presentation" class="icon-rating-star icon-rating-star-empty" viewBox="0 0 896 832">
                        <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
                      </svg>
                      <svg fill="none" focusable="false" role="presentation" class="icon-rating-star icon-rating-star-empty" viewBox="0 0 896 832">
                        <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
                      </svg>

                    </div>
                    <span class="rating-caption">
                      
                        (0)
                      
                    </span>
                  </div>
                              </div>

              <div
                class="product-card__price-row"
                style="
                  margin-top:6px;
                  display:flex;
                  align-items:baseline;
                  gap:6px;
                  flex-wrap:wrap;
                "
              >
                <span
                  class="product-card__price"
                  
                >
                   ${hit.price === 0 || hit.price === '0.00' ? 'POA' : teqDisplayPriceFromHit(hit, hit._distinct)}
                </span>

                ${!hit._distinct &&
        (algoliaShopify.helpers.displayStrikedPrice(
          hit.price,
          hit.compare_at_price
        ) &&
          html`
                    <span
                      class="product-card__price--striked"
                      style="
                        font-size:14px;
                        text-decoration:line-through;
                        color:#999999;
                      "
                    >
                      ${algoliaShopify.helpers.displayStrikedPrice(
            hit.price,
            hit.compare_at_price
          )}
                    </span>
                  `)}

               
              </div>
            </div>
          </a>

          ${!hit._distinct &&
        html`
            <form
              id="algolia-add-to-cart-${hit.objectID}"
              class="product-card__cart-form"
              action="/cart/add"
              method="post"
              enctype="multipart/form-data"
              style="margin:0;"
            >
              <input type="hidden" name="id" value="${hit.objectID}" />
            </form>

            <div class="product-card__footer">
              <a
              href="${productUrl}"
              class="product-card__button ais-hit--cart-button button button-secondary"
            >
              ${
                (window.productCompareStrings &&
                  window.productCompareStrings.viewProductButton) ||
                'View product'
              }
            </a>
            </div>
          `}
        </article>
      `;
    }
  );
});
